import { render, staticRenderFns } from "./detail_dialog.vue?vue&type=template&id=201ef2a6&scoped=true&"
import script from "./detail_dialog.vue?vue&type=script&lang=js&"
export * from "./detail_dialog.vue?vue&type=script&lang=js&"
import style0 from "./detail_dialog.vue?vue&type=style&index=0&id=201ef2a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ef2a6",
  null
  
)

export default component.exports